// The notification bell, on every phone screen.
//
// Each mobile page builds its own top bar, so a bell placed in one of them exists on
// exactly that page and a supervisor anywhere else would never see they had been sent
// anything. This mounts once, above everything, so it is wherever the person already
// is. Sharing is deliberately NOT here — you share a card, an item or a job, and a
// screen is none of those.
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import NotificationBell from './NotificationBell';

// The home screen carries its own in the top bar, where it looks native.
const HAS_ITS_OWN = ['/dashboard'];

export default function MobileChrome() {
  const location = useLocation();
  const [narrow, setNarrow] = useState(() => window.innerWidth < 900);

  useEffect(() => {
    const onResize = () => setNarrow(window.innerWidth < 900);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const signedIn = (() => { try { return !!JSON.parse(localStorage.getItem('titan_session') || 'null')?.token; } catch { return false; } })();
  const path = location.pathname;
  if (!narrow || !signedIn) return null;
  if (path === '/' || HAS_ITS_OWN.includes(path)) return null;
  // The desktop shell has its own pair in the sidebar.
  if (path.startsWith('/admin') && window.innerWidth >= 900) return null;

  return (
    // Bottom right, clear of the bottom bar where there is one, so it never covers
    // the thing being read.
    <div style={{
      position: 'fixed', right: 12, bottom: 'calc(env(safe-area-inset-bottom, 0px) + 78px)',
      zIndex: 5000, display: 'flex', flexDirection: 'column', gap: 8,
    }}>
      <div style={{
        width: 44, height: 44, borderRadius: 22, background: '#fff',
        border: '1px solid #e5e7eb', boxShadow: '0 3px 12px rgba(0,0,0,0.16)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}>
        <NotificationBell placement="topbar" />
      </div>
    </div>
  );
}
